import request from "@/utils/request";
const projectName = "/api/blade-platform";
const projectNameTwo = "/api/blade-workbench";
export const EIdCode = params => {
    return request({
        url: `${projectName}/digitalCredential/configDetail`,
        method: "post",
        data: params
    });
};
export const pullDownOption = params => {
    return request({
        url: `${projectNameTwo}/eduFieldConfig/list`,
        method: "post",
        data: params
    });
};
export const save = params => {
    return request({
        url: `${projectName}/digitalCredential/saveConfig`,
        method: "post",
        data: params
    });
};
